import * as actionTypes from './actionTypes';

export const modal = (modal) => {
  return {
    type: actionTypes.MODAL,
    modal: modal,
  };
};

export const isLoading = (isLoading) => {
  return {
    type: actionTypes.IS_LOADING,
    isLoading: isLoading,
  };
};

export const clearError = () => {
  return {
    type: actionTypes.CLEAR_ERROR,
  };
};

export const setError = (Error, Timer) => {
  return {
    type: actionTypes.SHOW_ERROR,
    showError: Error,
    timer: Timer,
  };
};

export const showError = (Error) => {
  return (dispatch) => {
    const timer = setTimeout(() => dispatch(clearError()), 3000);
    dispatch(setError(Error, timer));
  };
};
